
import {
  GET_SEND_PRODUCT_REQUEST,
  GET_SEND_PRODUCT_SUCCESS,
  GET_SEND_PRODUCT_ERROR
} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SEND_PRODUCT_REQUEST:
      return {
        loading: true,
      };
    case GET_SEND_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SEND_PRODUCT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};